<script>
import { filters } from '../../../utils/index'
import { h } from 'vue'
export default {
  name: 'PgReadText',
  props: {
    // 是否删除空白符
    whiteSpace: {
      type: Boolean,
      default: false,
    },
    value: null,
    type: '',
    format: '',
    symbol: '',
    isLongText: {
      type: Boolean,
      default: false,
    },
    title: {
      type: Boolean,
      default: false,
    },
    // 当值不存在的时候用符号("-")代替
    noValueSymbol: {
      type: String,
      default: '-',
    },
    // 是否显示穿过文本的线
    lineThrough: {
      type: Boolean,
      default: false,
    },
    // 是否显示code
    isShowCode: {
      type: String,
      default: '',
    },
    ifHtml: Boolean,
  },
  setup(props) {
    return () => {
      const { value, noValueSymbol } = props
      if (!value && value !== 0 && value !== false) {
        return h('span', { class: { 'pg-readText-span': true } }, [noValueSymbol])
      } else {
        const { isLongText, title, whiteSpace, lineThrough, type, format, symbol, isShowCode } =
          props
        let fValue = type ? filters(value, type, format, symbol) || '-' : value
        if (isShowCode) {
          fValue = '(' + isShowCode + ')' + fValue
        }
        return props.ifHtml
          ? h('span', { domProps: { innerHTML: fValue } })
          : h(
              'span',
              {
                class: {
                  'pg-readText-span': true,
                  'pg-notwrap': isLongText,
                  'pg-white-space': whiteSpace,
                  'pg-line-through': lineThrough,
                },
                attrs: {
                  title: isLongText || title ? fValue : '',
                },
              },
              [fValue]
            )
      }
    }
  },
}
</script>
<style lang="scss">
@import '../style/read-text.scss';
</style>
